import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DiamondIcon from "@mui/icons-material/Diamond";
import StarIcon from "@mui/icons-material/Star";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const theme = createTheme({
  palette: {
    primary: { main: "#0f63a5" },
  },

});

const data = [
  {
    icon: <CurrencyRupeeIcon />,
    title: "High Earnings",
    desc: "Competitive compensation packages that reflect your expertise and market value. Performance-based growth opportunities.",
  },
  {
    icon: <DiamondIcon />,
    title: "Elite Network",
    desc: "Connect with industry leaders, innovators, and visionaries. Build relationships that shape your career trajectory.",
  },
  {
    icon: <StarIcon />,
    title: "Personal Brand Growth",
    desc: "Amplify your influence through speaking opportunities, thought leadership, and industry recognition.",
  },
];

const WhyJoinUsLuxury: React.FC = () => {
  const cardsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    // 🔥 Reveal Animation (blur + fade + slide)
    gsap.from(cardsRef.current, {
      scrollTrigger: {
        trigger: cardsRef.current[0],
        start: "top 80%",
      },
      y: 80,
      opacity: 1,
    //   filter: "blur(10px)",
      duration: 1.2,
      stagger: 0.25,
      ease: "power4.out",
    });
  }, []);

  // 🔥 Magnetic Hover Effect
  const handleMouseMove = (e: any, el: any) => {
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const moveX = (x - rect.width / 2) / 20;
    const moveY = (y - rect.height / 2) / 20;

    gsap.to(el, {
      x: moveX,
      y: moveY,
      rotateX: -moveY,
      rotateY: moveX,
      transformPerspective: 500,
      duration: 0.4,
      ease: "power2.out",
    });
  };

  const resetCard = (el: any) => {
    gsap.to(el, {
      x: 0,
      y: 0,
      rotateX: 0,
      rotateY: 0,
      duration: 0.6,
      ease: "power3.out",
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box sx={{ py: 12, background: "#ffffff" }}>
        <Container>
          {/* Title */}
          <Box sx={{ mb: 10 }}>
            <Typography
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                color: "#0f63a5",
                fontWeight: 500,
              }}
            >
              Why Join Us
            </Typography>

            {/* Luxury underline */}
            {/* <Box
              sx={{
                width: 80,
                height: 4,
                background:
                  "linear-gradient(90deg, #0f63a5, #d4af37)",
                mt: 1,
                borderRadius: 2,
              }}
            /> */}
          </Box>

          {/* Cards */}
          <Grid container spacing={6}>
            {data.map((item, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box
                  // ref={(el: any) => (cardsRef.current[index] = el)}
                  // onMouseMove={(e) =>
                  //   handleMouseMove(e, cardsRef.current[index])
                  // }
                  // onMouseLeave={() =>
                  //   resetCard(cardsRef.current[index])
                  // }
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    background:
                      "linear-gradient(145deg, #ffffff, #f5f7fa)",
                    boxShadow:
                      "0 10px 30px rgba(0,0,0,0.08)",
                    transition: "all 0.4s ease",
                    cursor: "pointer",

                    "&:hover": {
                      boxShadow:
                        "0 25px 60px rgba(15, 99, 165, 0.25)",
                    },

                    "&:hover .icon": {
                      transform: "scale(1.2)",
                      boxShadow:
                        "0 0 20px rgba(15,99,165,0.6)",
                    },
                  }}
                >
                  {/* Icon */}
                  <Box
                    className="icon"
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #0f63a5, #1e88e5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      mb: 3,
                      transition: "all 0.4s ease",
                    }}
                  >
                    {item.icon}
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      fontSize: "1.5rem",
                      fontWeight: 600,
                      mb: 2,
                      color:"black"
                    }}
                  >
                    {item.title}
                  </Typography>

                  {/* Desc */}
                  <Typography
                    sx={{
                      color: "#555",
                      lineHeight: 1.8,
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default WhyJoinUsLuxury;